import React, { useEffect } from "react";
import {
  FieldInputTextProps,
  FieldInputText,
  MultiFieldInputText,
} from "./text";
import { FieldInputPassword, FieldInputPasswordProps } from "./password";
import { FieldInputCheckbox, FieldInputCheckboxProps } from "./checkbox";
import {
  FieldInputCheckboxMulti,
  FieldInputCheckboxMultiProps,
} from "./checkboxMulti";
import { FieldInputRadio, FieldInputRadioProps } from "./radio";
import { FieldInputNumber, FieldInputNumberProps } from "./number";
import {
  FieldInputFile,
  FieldInputFileProps,
  FieldInputMultiFileProps,
  MultiFieldFileInput,
} from "./file";
import { FieldInputPhoneNumberProps, FieldPhoneNumber } from "./phoneNumber";
import {
  FieldDatePicker,
  FieldInputDatePickerProps,
  FieldDateTimePicker,
  FieldInputDateTimePickerProps,
} from "./datepicker";
import { FieldInputDropzone, FieldInputDropzoneProps } from "./dropzone";
import { FieldInputPin, FieldInputPinProps } from "./pin";
import { FieldInputDropdown, FieldInputDropdownProps } from "./dropdown";
import {
  FieldInputMultiDropdown,
  FieldInputMultiDropdownProps,
} from "./multiDropdown";
import {
  FieldInputAutocomplete,
  FieldInputAutocompleteProps,
} from "./autocomplete";
import {
  FieldInputTextarea,
  FieldInputTextareaProps,
  MultiFieldInputTextarea,
} from "./textArea";
import { FieldHiddenProps, FiledHidden } from "./hidden";
import { FieldInputCheckboxGroup, FieldInputCheckboxGroupProps } from "./checkboxGroup";

type FieldProps = {
  label: string;
  children?: React.ReactNode;
};

export interface FieldComponent extends React.FC<FieldProps> {
  Text: React.FC<FieldInputTextProps>;
  Password: React.FC<FieldInputPasswordProps>;
  Checkbox: React.FC<FieldInputCheckboxProps>;
  CheckboxMulti: React.FC<FieldInputCheckboxMultiProps>;
  CheckboxGroup: React.FC<FieldInputCheckboxGroupProps>;
  Radio: React.FC<FieldInputRadioProps>;
  Number: React.FC<FieldInputNumberProps>;
  File: React.FC<FieldInputFileProps>;
  PhoneNumber: React.FC<FieldInputPhoneNumberProps>;
  DatePicker: React.FC<FieldInputDatePickerProps>;
  DateTimePicker: React.FC<FieldInputDateTimePickerProps>;
  Pin: React.FC<FieldInputPinProps>;
  Dropdown: React.FC<FieldInputDropdownProps>;
  MultiDropdown: React.FC<FieldInputMultiDropdownProps>;
  Hidden: React.FC<FieldHiddenProps>;
  Autocomplete: React.FC<FieldInputAutocompleteProps>;
  Textarea: React.FC<FieldInputTextareaProps>;
  Dropzone: React.FC<FieldInputDropzoneProps>;
}

export interface MultiFieldComponent extends React.FC<FieldProps> {
  Text: React.FC<FieldInputTextProps>;
  Textarea: React.FC<FieldInputTextareaProps>;
  File: React.FC<FieldInputMultiFileProps>;
}

const Field: FieldComponent = ({ children }: FieldProps) => {
  return <div>{children}</div>;
};

// Attach subcomponents to `Field`
Field.Hidden = FiledHidden;
Field.Text = FieldInputText;
Field.Password = FieldInputPassword;
Field.Checkbox = FieldInputCheckbox;
Field.CheckboxMulti = FieldInputCheckboxMulti;
Field.Radio = FieldInputRadio;
Field.Number = FieldInputNumber;
Field.File = FieldInputFile;
Field.PhoneNumber = FieldPhoneNumber;
Field.DatePicker = FieldDatePicker;
Field.DateTimePicker = FieldDateTimePicker;
Field.Pin = FieldInputPin;
Field.Dropzone = FieldInputDropzone;
Field.Dropdown = FieldInputDropdown;
Field.MultiDropdown = FieldInputMultiDropdown;
Field.Autocomplete = FieldInputAutocomplete;
Field.Textarea = FieldInputTextarea;
Field.CheckboxGroup = FieldInputCheckboxGroup;

const MultiField: MultiFieldComponent = ({ children }: FieldProps) => {
  return <div>{children}</div>;
};

MultiField.Text = MultiFieldInputText;
MultiField.Textarea = MultiFieldInputTextarea;
MultiField.File = MultiFieldFileInput;

export { MultiField };

export default Field;
